import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import CNActions from '@Actions/cnActions';
import Helpers from '@Apis/helpers';
import { toISTDate } from '@Apis/constants';
import './style.scss';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';

/**
 *
 */
class CusotmerCreditNoteList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);

    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

    this.state = {
      currentPage: 1,
      startDate: dayjs().valueOf(),
      openSelectedDuration: dayjs().subtract(300, 'd').valueOf(),
      closedSelectedDuration: 'LAST 60 DAYS',
      tableColumns: [
        {
          title: '',
          render: (record) => (
            <Link to={`/sales/credit-note/view/${record.cn_id}`}>
              <div className="mobile-list__item">
                <div style={{ display: 'flex' }}>
                  <H3Text text={`#${record?.credit_note_number}`} className="mobile-list__item-number" />
                  <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
                    {Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  </div>
                </div>
                { record?.customer_info && (
                  <div className="mobile-list__item-info">
                    {`Customer - ${record?.customer_info?.customer_name}`}
                  </div>
                )}
                {record?.invoice_id && <H3Text text={`Invoice Number - ${record?.invoice_number}`} className="mobile-list__item-info" />}
                <H3Text text={`Amount - ${this.props.MONEY(record?.cn_grand_total || '0')}`} className="mobile-list__item-info" />
                <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
              </div>
            </Link>
          ),
          responsive: ['xs'],
        },
        {
          title: 'CREDIT NOTE #',
          dataIndex: 'credit_note_number',
          responsive: ['sm', 'md', 'lg', 'xxl'],

        },
        {
          title: 'SO NUMBER',
          responsive: ['sm', 'md', 'lg', 'xxl'],

          render: (record) => (
            <Fragment>
              {record.order_id
                ? <div style={{ fontWeight: '600' }}><Link style={{ color: '#2D7DF7' }} to={`/sales/sales-order/view/${record.order_id}`} target="_blank">{record.sales_order_number !== null ? record.sales_order_number : '-'}</Link></div> : '-'}
            </Fragment>
          ),
        },
        {
          title: 'INVOICE NUMBER',
          responsive: ['sm', 'md', 'lg', 'xxl'],

          render: (record) => (
            <Fragment>
              {record?.invoice_id ? (
                <div className="customer-credit-note__invoice-number" style={{ fontWeight: '600' }}>
                  <Link to={`/sales/invoice/view/${record?.invoice_id}`} target="_blank">
                    {record?.invoice_number}
                  </Link>

                </div>
              ) : <div className="customer-credit-note__invoice-number">-</div>}
            </Fragment>
          ),
        },
        {
          title: 'AMOUNT',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (record) => ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view amount"} /> : this.props.MONEY(record?.cn_grand_total || '0', record?.org_currency_info?.currency_code)),
        },
        {
          title: 'CREATION DATE',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (record) => (
            <div>
              {toISTDate(record?.created_at).format('DD/MM/YYYY')}
              <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
            </div>
          ),
        },
        {
          title: 'STATUS',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (item) => (
            <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item?.status)?.color }}>
              {Helpers.getStatusColor(item?.status)?.text}
            </div>
          ),
        },
        {
          title: '',
          width: '100px',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (text, record) => {
            const { history, user } = this.props;
            return (
              <div style={{
                textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
              }}
              >
                {Helpers.getPermission(Helpers.permissionEntities.CREDIT_NOTE,
                  Helpers.permissionTypes.UPDATE, user) && !['VOID', 'CONFIRMED'].includes(record?.status?.toUpperCase()) && (
                  <div
                    className={`roundIconButton ${ (record?.status === 'CANCELLED') && 'button__disabled'}`}
                    onClick={() => {
                      if (!(record?.status === 'CANCELLED')) {
                        history.push(`/sales/credit-notes/update/${record?.cn_id}`);
                      }
                    }}
                  >
                    <EditOutlined />
                  </div>
                )}
                <div className="customer-credit-note-view-button" onClick={() => history.push(`/sales/credit-note/view/${record.cn_id}`)}>
                  View
                </div>
              </div>
            );
          },
        },
      ],
      showNewCustomerModal: false,
      showUpdateCustomerModal: false,
      searchKeyword: '',
      mobileVendorsLength: 10,
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    const { customerId } = props.match.params;

    if (props.user && !state.isUserReady) {
      const { currentPage } = state;
      const { getCN, user } = props;
      getCN(user?.tenant_info?.tenant_id, '', currentPage, 10, customerId);
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      creditNotes, getCNLoading, user, getCN, match,
    } = this.props;
    const {
      currentPage, tableColumns, searchKeyword, keyword,
    } = this.state;
    const { customerId } = match.params;

    return (
      <Fragment>
        <div className="customer-credit-notes__wrapper">
          <div className="ant-row">
            <div className="ant-col-xs-24">
              <div className="customer-credit-notes__table__wrapper">
                {searchKeyword && searchKeyword.length > 0 && (
                  <div className="search-bar__search-container__clear-button">
                    <H3Text
                      text={(
                        <React.Fragment>
                          Showing search results for&nbsp;
                          <i>
                            <b>
                              {`'${searchKeyword}'`}
                            </b>
                          </i>
                        </React.Fragment>
                      )}
                      className="section-search-keyword"
                    />
                    <H3Text
                      text="clear"
                      className="search-bar__clear-button"
                      onClick={() => {
                        this.setState({ searchKeyword: '', keyword: '', currentPage: 1 });
                        getCN(user?.tenant_info?.tenant_id, '', 1, 10, customerId);
                      }}
                    />
                  </div>
                )}
                <div className="customer-credit-notes__table__data">
                  <Table
                    title={() => `${(creditNotes && creditNotes?.data?.count) ? creditNotes?.data?.count : '0'} Credit Notes`}
                    loading={getCNLoading}
                    showHeader
                    size="small"
                    scroll="scroll"
                    columns={tableColumns}
                    dataSource={creditNotes && creditNotes?.data?.credit_notes ? creditNotes?.data?.credit_notes : []}
                    pagination={creditNotes?.data?.count > 10 ? {
                      defaultCurrent: 1,
                      current: currentPage,
                      total: creditNotes ? creditNotes?.data?.count : 0,
                      pageSize: 10,
                      onChange: (page) => {
                        this.setState({ currentPage: page });
                        getCN(user?.tenant_info?.tenant_id, keyword, page, 10, customerId);
                      },
                      position: ['bottomRight'],
                      showSizeChanger: false,
                    } : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, CNReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getCNLoading: CNReducers.getCNLoading,
  creditNotes: CNReducers.creditNotes,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getCN: (tenantId, cnId, page, limit, customerId) => dispatch(CNActions.getCN(tenantId, cnId, page, limit, customerId)),
});

CusotmerCreditNoteList.propTypes = {
  getCN: PropTypes.func,
  creditNotes: PropTypes.any,
  user: PropTypes.any,
  getCNLoading: PropTypes.bool,
  history: PropTypes.func,
  customerId: PropTypes.any,
  params: PropTypes.any,
  match: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CusotmerCreditNoteList));
